import { CreatorStatus } from '../enums';

/** Public-facing creator metrics snapshot. Values are placeholders until analytics pipeline exists. */
export interface CreatorMetrics {
  followers: number;
  /** Placeholder engagement score (0–100). Not used in ranking yet. */
  engagementScore: number;
  /** Placeholder earnings summary linked to purchase activity. */
  earningsPlaceholder: number;
}

/**
 * CreatorProfile extends a User into a creator identity.
 * Creator is not a separate lifecycle — it is an evolution of User.
 */
export interface CreatorProfile {
  id: string;
  userId: string;
  status: CreatorStatus;
  bio: string | null;
  links: string | null;
  branding: string | null;
  metrics: CreatorMetrics;
  createdAt: Date;
  updatedAt: Date;
}

/** Default metrics for a newly activated creator profile. */
export function createDefaultCreatorMetrics(followers = 0): CreatorMetrics {
  return {
    followers,
    engagementScore: 0,
    earningsPlaceholder: 0,
  };
}
